import React, { useEffect, useState } from "react";
import NavigationBanner from "../../components/common/NavigationBanner";
import HeaderBg from "../../Assets/Images/our-team/OurTeam_BG.png";
import axiosInstance from "../../utils/axios";

// ---------------- SKELETON -------------------
const PartnerSkeleton = () => (
  <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6 md:p-8 h-48 animate-pulse">
    <div className="w-full h-full flex flex-col items-center justify-center">
      <div className="w-24 h-24 bg-gray-200 rounded-full mb-4" />
      <div className="w-24 h-3 bg-gray-200 rounded" />
    </div>
  </div>
);

// ---------------- EMPTY VIEW -------------------
const PartnersEmptyView = () => (
  <div className="col-span-full flex flex-col items-center py-10">
    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-3">
      <span className="text-3xl text-gray-400">🤝</span>
    </div>
    <h3 className="text-lg font-semibold text-gray-700">No Partners Found</h3>
    <p className="text-gray-500 text-sm mt-1 text-center max-w-xs">
      We currently don’t have partners to display.
    </p>
  </div>
);

const SupportPartners = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPartners = async () => {
    try {
      const resp = await axiosInstance.get("/partners");
      const data = resp?.data?.data ?? [];

      const formatted = data.map((p) => ({
        id: p._id,
        name: p.name,
        logo: p.logo,
        hasLogo: p.hasLogo,
      }));

      setPartners(formatted);
    } catch (err) {
      console.error("Partner fetch error:", err);
      setPartners([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPartners();
  }, []);

  return (
    <div>
      <NavigationBanner title={"Our Support Partners"} background={HeaderBg} />

      <section className="py-16 px-4 md:px-8 lg:px-16 bg-gradient-to-b from-white to-primaryFadedColor/20">
        {/* Section Header */}
        <div className="max-w-7xl mx-auto mb-12 text-center" data-aos="fade-up">
          <h2 className="text-3xl md:text-4xl font-bold text-primaryTextColor mb-4">
            Our Valued Partners
          </h2>
          <div className="w-24 h-1 bg-accentColor mx-auto mb-6"></div>
          <p className="text-secondaryTextColor max-w-2xl mx-auto text-lg">
            We are grateful to our support partners who believe in our mission
            and help us create lasting impact in the community.
          </p>
        </div>

        {/* PARTNER GRID */}
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
          {/* LOADING SKELETONS */}
          {loading &&
            Array.from({ length: 8 }).map((_, i) => (
              <PartnerSkeleton key={i} />
            ))}

          {/* EMPTY STATE */}
          {!loading && partners.length === 0 && <PartnersEmptyView />}

          {/* DYNAMIC PARTNERS */}
          {!loading &&
            partners.length > 0 &&
            partners.map((partner, index) => (
              <div
                key={partner.id}
                className="group relative bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 hover:border-primaryColor/30"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                {/* Decorative corner accent */}
                <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-primaryColor/10 to-transparent rounded-bl-full transition-all duration-500 group-hover:w-32 group-hover:h-32"></div>

                {/* Card Content */}
                <div className="relative p-6 md:p-8 h-48 flex flex-col items-center justify-center">
                  {partner.hasLogo ? (
                    <div className="w-full h-full flex items-center justify-center">
                      <img
                        src={partner.logo}
                        alt={`${partner.name} logo`}
                        className="max-w-full max-h-32 object-contain transition-transform duration-500 group-hover:scale-110"
                      />
                    </div>
                  ) : (
                    <div className="w-full h-full flex flex-col items-center justify-center text-center">
                      <div className="w-16 h-16 mb-4 rounded-full bg-gradient-to-br from-primaryColor to-primaryColor/70 flex items-center justify-center transition-transform duration-500 group-hover:scale-110 group-hover:rotate-12">
                        <span className="text-2xl font-bold text-white">
                          {partner.name.charAt(0)}
                        </span>
                      </div>
                      <h3 className="text-primaryTextColor font-medium text-base leading-snug tracking-wide">
                        {partner.name}
                      </h3>
                    </div>
                  )}
                </div>

                {/* Hover Effect Overlay */}
                <div className="absolute inset-x-0 bottom-0 h-1 bg-gradient-to-r from-primaryColor via-accentColor to-primaryColor transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>

                {/* Tooltip */}
                {partner.hasLogo && (
                  <div className="absolute inset-x-0 bottom-0 bg-primaryColor/95 text-white text-center py-2 px-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                    <p className="text-sm font-medium">{partner.name}</p>
                  </div>
                )}
              </div>
            ))}
        </div>
      </section>
    </div>
  );
};

export default SupportPartners;

// import React from "react";
// import NavigationBanner from "../../components/common/NavigationBanner";
// import HeaderBg from "../../Assets/Images/our-team/OurTeam_BG.png";
// import BrplLogo from "../../Assets/Images/our-partners/brpl_logo.png";
// import CureBayLogo from "../../Assets/Images/our-partners/curebay_logo.jpg";
// import KgiLogo from "../../Assets/Images/our-partners/kgi_logo.png";
// import OilIndiaLogo from "../../Assets/Images/our-partners/oil_india_logo.png";

// const SupportPartners = () => {
//   const partners = [
//     {
//       id: 1,
//       name: "Kalinga Group of Institutions",
//       logo: KgiLogo,
//       hasLogo: true,
//     },
//     {
//       id: 2,
//       name: "Oil India Ltd",
//       logo: OilIndiaLogo,
//       hasLogo: true,
//     },
//     {
//       id: 6,
//       name: "Brahmani River Pellet Limited",
//       logo: BrplLogo,
//       hasLogo: true,
//     },
//     {
//       id: 7,
//       name: "Cure Bay",
//       logo: CureBayLogo,
//       hasLogo: true,
//     },
//     {
//       id: 3,
//       name: "Neolan Industries Private Limited",
//       logo: null,
//       hasLogo: false,
//     },
//     {
//       id: 4,
//       name: "Skal Media Network and Entertainment Private Limited",
//       logo: null,
//       hasLogo: false,
//     },
//     {
//       id: 5,
//       name: "Molvate Infra Private Limited",
//       logo: null,
//       hasLogo: false,
//     },
//     {
//       id: 8,
//       name: "Edumystic knowledge foundation",
//       logo: null,
//       hasLogo: false,
//     },
//   ];

//   return (
//     <div>
//       <NavigationBanner title={"Our Support Partners"} background={HeaderBg} />

//       <section className="py-16 px-4 md:px-8 lg:px-16 bg-gradient-to-b from-white to-primaryFadedColor/20">
//         {/* Section Header */}
//         <div className="max-w-7xl mx-auto mb-12 text-center" data-aos="fade-up">
//           <h2 className="text-3xl md:text-4xl font-bold text-primaryTextColor mb-4">
//             Our Valued Partners
//           </h2>
//           <div className="w-24 h-1 bg-accentColor mx-auto mb-6"></div>
//           <p className="text-secondaryTextColor max-w-2xl mx-auto text-lg">
//             We are grateful to our support partners who believe in our mission
//             and help us create lasting impact in the community.
//           </p>
//         </div>

//         {/* Partners Grid */}
//         <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
//           {partners.map((partner, index) => (
//             <div
//               key={partner.id}
//               className="group relative bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 hover:border-primaryColor/30"
//               data-aos="fade-up"
//               data-aos-delay={index * 100}
//             >
//               {/* Decorative corner accent */}
//               <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-primaryColor/10 to-transparent rounded-bl-full transition-all duration-500 group-hover:w-32 group-hover:h-32"></div>

//               {/* Card Content */}
//               <div className="relative p-6 md:p-8 h-48 flex flex-col items-center justify-center">
//                 {partner.hasLogo ? (
//                   // Logo Card
//                   <div className="w-full h-full flex items-center justify-center">
//                     <img
//                       src={partner.logo}
//                       alt={`${partner.name} logo`}
//                       className="max-w-full max-h-32 object-contain transition-transform duration-500 group-hover:scale-110 filter grayscale-0 group-hover:grayscale-0"
//                     />
//                   </div>
//                 ) : (
//                   // Text Card
//                   <div className="w-full h-full flex flex-col items-center justify-center text-center">
//                     <div className="w-16 h-16 mb-4 rounded-full bg-gradient-to-br from-primaryColor to-primaryColor/70 flex items-center justify-center transition-transform duration-500 group-hover:scale-110 group-hover:rotate-12">
//                       <span className="text-2xl h-full flex items-center justify-center  font-bold text-white">
//                         {partner.name.charAt(0)}
//                       </span>
//                     </div>
//                     <h3 className="text-primaryTextColor font-medium text-base  leading-snug tracking-wide">
//                       {partner.name}
//                     </h3>
//                   </div>
//                 )}
//               </div>

//               {/* Hover Effect Overlay */}
//               <div className="absolute inset-x-0 bottom-0 h-1 bg-gradient-to-r from-primaryColor via-accentColor to-primaryColor transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>

//               {/* Tooltip on hover for logo cards */}
//               {partner.hasLogo && (
//                 <div className="absolute inset-x-0 bottom-0 bg-primaryColor/95 text-white text-center py-2 px-3 transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
//                   <p className="text-sm font-medium">{partner.name}</p>
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>

//         {/* Bottom decoration */}
//         {/* <div
//           className="max-w-7xl mx-auto mt-16 text-center"
//           data-aos="fade-up"
//           data-aos-delay="400"
//         >
//           <div className="inline-flex items-center gap-2 text-secondaryTextColor">
//             <div className="w-12 h-px bg-gradient-to-r from-transparent to-accentColor"></div>
//             <span className="text-sm font-medium">
//               Trusted by Industry Leaders
//             </span>
//             <div className="w-12 h-px bg-gradient-to-l from-transparent to-accentColor"></div>
//           </div>
//         </div> */}
//       </section>
//     </div>
//   );
// };

// export default SupportPartners;
